import { Metric } from 'web-vitals';

import log from './ScalyrLogger';

const metricQueue: Metric[] = [];

const MAX_QUEUE_SIZE = 30;

// Waiting to send events until we have the knob value
let shouldSendMetrics = false;

// Prefix used for the WebVitals metric attributes
const METRIC_PREFIX = 'vitals';

/**
 * For easier consumption and parsing, we append `vitals.` to each of the object keys, so it would look like:
 * {
 *    vitals.delta: 2532.5999999940395,
 *    vitals.id: 'v2-1649314009059-2359945848456',
 *    vitals.name: 'FCP',
 *    vitals.value: 2532.5999999940395,
 *    ...
 * }
 */
const prefixMetricAttributeKeys = (metric: Metric) =>
  Object.fromEntries(Object.entries(metric).map(([key, value]) => [`${METRIC_PREFIX}.${key}`, value]));

const sendMetric = (metric: Metric) => {
  log.info({
    ...prefixMetricAttributeKeys(metric),
    _type: 'WebVitals',
  });
};

const sendAllQueueMetrics = () => {
  while (metricQueue.length > 0) {
    const metric = metricQueue.shift();
    if (metric) {
      sendMetric(metric);
    }
  }
};

const addMetricToQueue = (metric: Metric) => {
  metricQueue.push(metric);

  if (shouldSendMetrics) {
    sendAllQueueMetrics();
  }

  if (metricQueue.length > MAX_QUEUE_SIZE) {
    metricQueue.shift();
  }
};

export const webVitalsReportHandler = (metric: Metric) => {
  addMetricToQueue(metric);
};

export const startSendingMetrics = () => {
  shouldSendMetrics = true;
  sendAllQueueMetrics();
};
